import { Mezo } from "@mezo/sdk"
import { JsonRpcSigner } from "ethers"
import { providers } from "ethers-v5"

import {
  ETHEREUM_PROVIDER,
  MEZO_NETWORK,
  MEZO_PROVIDER,
} from "#/shared/constants"
import { sentryConfig } from "#/shared/hooks/sentry"

// TODO: adjust types - these signers can be either resular Ethers signers or
// Ethers wrappers around bitcoin signers. In that case they will have some
// additional methods like getBitcoinAddress() etc.
// Also we need to check if `isBitcoinSigner` is true the the signers need to be
// bitcoin signers. If these values don't match we need to handle that case gracefully.
export type SdkSigners = {
  signerEthersV6: JsonRpcSigner
  signerEthersV5: providers.JsonRpcSigner
  signerMezo: JsonRpcSigner
  isBitcoinSigner: boolean
}

class SDK {
  public readonly mezo: Mezo

  constructor(mezo: Mezo) {
    this.mezo = mezo
  }

  async connectSigner({
    signerEthersV6,
    signerEthersV5,
    signerMezo,
    isBitcoinSigner,
  }: SdkSigners) {
    if (signerEthersV6 && signerEthersV5 && signerMezo) {
      await this.mezo.connectSigner(
        signerEthersV6,
        signerEthersV5,
        ETHEREUM_PROVIDER,
        signerMezo,
        MEZO_PROVIDER,
        MEZO_NETWORK,
        isBitcoinSigner,
      )
    } else {
      this.mezo.disconnectSigner()
      throw new Error("Wallet signer not found.")
    }
  }

  async disconnectSigner() {
    this.mezo.disconnectSigner()
  }

  static async inititalize(): Promise<SDK> {
    const mezo = Mezo.initialize(sentryConfig)

    return new SDK(mezo)
  }
}

const sdk = await SDK.inititalize()

window.sdk = sdk

export default sdk
